import React from 'react';
import { sprintf } from 'sprintf-js';

import Box from 'components/Box';
import { LinkButton, PrimaryButton } from 'components/Button';
import { BodySmall, H4 } from 'components/Text';
import { SmallTile } from 'components/Tile';
import ShowModalContainer from 'containers/ShowModalContainer';
import { trackClicked } from 'utils/analytics';
import {
  LISTING_TYPE_HUMAN_NAME_MAP_TITLE,
  LISTING_TYPE_PLURAL_HUMAN_NAME_MAP,
} from 'utils/constants';

import { gutterWidth } from '../theme';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const ListingSignupCta = ({
  listingUrl,
  type,
}: {
  listingUrl: string;
  type: string;
}) => (
  <Box data-qa-id="job-listing-signup-promo">
    <SmallTile blueBorder p={[gutterWidth / 2, null, gutterWidth]}>
      <H4>{getText('Join Idealist')}</H4>
      <BodySmall>
        {sprintf(
          getText(
            'Sign up today to save your favorite %(type)s and get email alerts when new ones are posted.'
          ),
          {
            type: LISTING_TYPE_PLURAL_HUMAN_NAME_MAP[type],
          }
        )}
      </BodySmall>
      <ShowModalContainer
        render={(showModal) => (
          <>
            <Box mt={36} mx="auto">
              <PrimaryButton
                onClick={(e) => {
                  e.preventDefault();
                  trackClicked(
                    `${LISTING_TYPE_HUMAN_NAME_MAP_TITLE[type]} Listing CTA: Sign Up`
                  );
                  showModal('SIGNUP', {
                    redirectTo: listingUrl,
                  });
                }}
                data-qa-id="listing-promo-signup-link"
              >
                {getText('Get Started')}
              </PrimaryButton>
            </Box>
            <Box mt={24} mx="auto">
              <LinkButton
                onClick={() => {
                  trackClicked(
                    `${LISTING_TYPE_HUMAN_NAME_MAP_TITLE[type]} Listing CTA: Log In`
                  );
                  showModal('LOGIN', {
                    redirectTo: listingUrl,
                  });
                }}
                data-qa-id="listing-promo-login-link"
              >
                <BodySmall styleAs="h5">
                  {getText('Already a user? Log in')}
                </BodySmall>
              </LinkButton>
            </Box>
          </>
        )}
      />
    </SmallTile>
  </Box>
);

export default ListingSignupCta;
